import { LayoutDashboard, Bell, Video, MapPin, ShieldAlert, Radio, Siren, Settings2, ClipboardList, Scan, Building2, Monitor, PowerOff, UserPlus, Tag, TrendingUp, Megaphone, Banknote, FileText, Package, ListChecks, Repeat, Wallet, CreditCard } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { Permission } from '@asi/shared';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  highlight?: boolean;
  /** User must have this permission for the item to appear in the sidebar */
  requiredPermission?: Permission;
  /** User must have at least one of these permissions for the item to appear */
  requiredAnyPermission?: Permission[];
  /** If true, item is only visible to super_admin role */
  requireSuperAdmin?: boolean;
  /** Sidebar highlight is active for any path that starts with this prefix */
  activePrefix?: string;
  /** Extra path prefixes (besides `to`) that should also highlight this item, for leaf items grouping several routes (e.g. Cuentas/Usuarios/Roles) */
  activePaths?: string[];
  children?: NavItem[];
}

export const navItems: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, requiredPermission: 'dashboard.view' },
  { to: '/emergency', label: 'Emergencias', icon: Siren, highlight: true, requiredPermission: 'emergency.view' },
  { to: '/arc/events', label: 'Alarmas', icon: ShieldAlert, requiredPermission: 'arc.events.view', activePaths: ['/arc/'] },
  {
    to: '/accounts',
    label: 'Cuentas',
    icon: Building2,
    requiredAnyPermission: ['accounts.view', 'users.view', 'users.manage_roles'],
    activePaths: ['/users', '/roles'],
  },
  { to: '/join-requests', label: 'Solicitudes', icon: UserPlus, requiredPermission: 'accounts.view', activePaths: ['/onboarding-requests'] },
  {
    to: '/devices',
    label: 'Dispositivos',
    icon: Monitor,
    requiredPermission: 'cameras.view',
    activePrefix: '/devices',
    children: [
      { to: '/devices/cameras', label: 'En Vivo', icon: Video, requiredPermission: 'cameras.view' },
      { to: '/devices/panels', label: 'Páneles', icon: Radio, requiredPermission: 'alarms.view' },
      { to: '/devices/registro', label: 'Cámaras/NVR', icon: Scan, requiredPermission: 'cameras.manage' },
      { to: '/devices/inactivos', label: 'Bajas', icon: PowerOff, requiredPermission: 'cameras.view' },
    ],
  },
  { to: '/geofences', label: 'Geocercas', icon: MapPin, requiredPermission: 'geofences.view' },
];

export const systemNavItems: NavItem[] = [
  { to: '/admin/plans', label: 'Planes', icon: Tag, requiredPermission: 'plans.view' },
  { to: '/admin/revenue', label: 'Ingresos', icon: TrendingUp, requiredPermission: 'revenue.view' },
  { to: '/admin/communications', label: 'Comunicaciones', icon: Megaphone, requiredPermission: 'communications.view' },
  {
    to: '/admin/billing',
    label: 'Facturación y cobros',
    icon: Wallet,
    requiredAnyPermission: ['billing.view', 'billing.manage', 'collections.view'],
    activePrefix: '/admin/billing',
    children: [
      { to: '/admin/collections',           label: 'Cobros',              icon: Banknote,    requiredPermission: 'collections.view' },
      { to: '/admin/billing/invoices',       label: 'Facturas',            icon: FileText,    requiredPermission: 'collections.view' },
      { to: '/admin/payments',              label: 'Pagos (QPay)',        icon: CreditCard,  requireSuperAdmin: true },
      { to: '/admin/fel',                   label: 'Facturación (FEL)',   icon: FileText,    requiredPermission: 'billing.manage' },
      { to: '/admin/billing/batch',         label: 'Facturación masiva',  icon: ListChecks,  requiredPermission: 'billing.manage' },
      { to: '/admin/billing/subscriptions', label: 'Contratos',           icon: Repeat,      requiredPermission: 'billing.view' },
      { to: '/admin/billing/products',      label: 'Productos',           icon: Package,     requiredPermission: 'billing.view' },
      { to: '/admin/billing/settings',      label: 'Configuración',       icon: Settings2,   requiredPermission: 'billing.manage' },
    ],
  },
  { to: '/settings', label: 'Configuración', icon: Settings2, requiredPermission: 'settings.manage' },
  { to: '/tickets', label: 'Historial', icon: Bell, requiredPermission: 'tickets.view' },
  { to: '/audit', label: 'Auditoría', icon: ClipboardList, requiredPermission: 'audit.view' },
];
